/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UserCreateRequestDto = {
  name: string;
  surname: string;
  email: string;
  locale?: UserCreateRequestDto.locale;
};
export namespace UserCreateRequestDto {
  export enum locale {
    EN = 'EN',
    LV = 'LV',
    NO = 'NO',
    FI = 'FI',
  }
}

